import { Coordinates } from './marker';

export class AddsCustomToolTip {

  public constructor() {
    if (!$('[data-popover="tooltip"]').length) {
      let $popoverContent = $('<div>').attr('data-popover-content', 'tooltip');
      let $popover = $('<div>').addClass('tooltip').attr('data-popover', 'tooltip').attr('data-placement', 'top');
      $('[data-js="map"]').append($popoverContent, $popover);
    }
  }

  public execute(marker: google.maps.marker.AdvancedMarkerElement, tooltip: string): void {
    google.maps.event.addListener(marker, 'mouseover', () => AddsCustomToolTip.showCustomTooltip(marker, tooltip));
    google.maps.event.addListener(marker, 'mouseout', () => AddsCustomToolTip.hideCustomToolTip());
  }

  static showCustomTooltip(marker: google.maps.marker.AdvancedMarkerElement, tooltip: string): void {
    let point = Coordinates.toPixel(marker.map, new google.maps.LatLng(marker.position));
    let $popover = $('[data-popover="tooltip"]');
    let $popoverContent = $('[data-popover-content="tooltip"]');

    $popoverContent.html(tooltip);
    $popover.css({
        left: point.x - $popoverContent.outerWidth() / 2 ,
      top: point.y - $popover.outerHeight()
    });
    $popover.popover('open');
  }

  static hideCustomToolTip(): void {
    $('[data-popover="tooltip"]').popover('close');
  }
}
